<template>
  <div>
        <false-dashboard>

            <!-- dashboard content area -->
            <div class="mt-5 ml-lg-5 pl-lg-4">
                <div class="d-flex align-items-center" v-if="invitee != null && pool != null">
                    <div class="col-lg-8 col-md-12 p-0">
                        <div class="mb-4 card border-0">
                            <div class="invitee-card card-body d-flex flex-wrap align-items-center mb-2">
                                <div class="avatar-image mr-3">
                                    <img src="@/assets/avatar-purple.png"
                                        class="img-fluid rounded-circle d-block" alt="avatar" 
                                        style="height:60px; width: 60px;"
                                    >
                                </div>
                                <div class="invitee-detail">
                                    <h6 class="font-weight-bold m-0">{{ invitee.name }}</h6>
                                    <p class="m-0">{{ invitee.email }}</p>
                                    <p class="m-0 small">{{ invitee.phone }}</p>
                                </div>
                                <div class="ml-auto">
                                    <div class="">
                                        <span class="badge badge-success"> <span class="fa fa-user-circle fa-sm"></span> Logged in</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- <h5 class="font-weight-bold pb-4 text-center">Pool Invite</h5> -->
                        <div class="card shadow-sm border-0">
                            <div class="card-body p-0 m-0">
                                <!-- <img src="@/assets/placeholder.png" alt="" style="width: 100%; height: 200px;"> -->
                                <div class="body-card px-lg-4 px-3 py-4">
                                    <div class="pool-details mb-3">
                                        <h5 class="font-weight-bold ">{{ pool.name }} </h5>
                                        <small class="text-muted">Organized by <span v-if="pool_convener != null">{{ poolConvenerName }}</span> </small>
                                    </div> <hr>

                                    <div class="about">
                                        <h6 class="font-weight-bold">Description</h6>
                                        <p>{{ pool.description}}</p>
                                    </div> <hr>

                                    <div class="mb-3">
                                        <p class="mb-5">You are to contribute the sum of:
                                            <span class="p font-weight-bold text-success">&#8358;{{ pool.amount_payable | moneyformat}}</span>
                                        </p>
                                        <div>
                                            <paystack
                                                :amount="amount"
                                                :email="invitee.email"
                                                :paystackkey="paystack_key"
                                                :reference="paystack_reference"
                                                :callback="callback"
                                                :close="close"
                                                :embed="false"
                                            >
                                            Contribute &#8358;{{ pool.amount_payable | moneyformat }}
                                            </paystack>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-3 d-flex align-items-center">
                    <a href="/dashboard" class="btn btn-link btn-sm"> Go to Dashboard</a>
                </div>
            </div>

        </false-dashboard>
  </div>
</template>

<script>
import paystack from 'vue-paystack';
import { mapGetters } from 'vuex';
import FalseDashboard from '@/components/FalseDashboard'

export default {
    name: 'MakeContribution',
    components: {
        paystack,
        FalseDashboard
    },
    data() {
        return {
            pool_id: this.$route.params.pool_id,
            invite_id: this.$route.params.invite_id,
            paystack_key: process.env.VUE_APP_PAYSTACK_PUBLIC_KEY, //paystack public key
            paystack_reference: 'xxx',
            payment_reference: '',
            paymentSuccess: false
        }
    },
    created() {
        this.$store.dispatch('getPool', this.pool_id);
        this.$store.dispatch('getInviteeDetails', this.invite_id);
        this.getPaymentReference();
    },
    watch: {
        pool() {
            this.$store.dispatch('getPoolConvener', this.pool.account_id)
        }
    },
    computed: {
        ...mapGetters([
            'invitee',
            'pool',
            'pool_convener',
            'pool_invitees'
        ]),

        amount() {
            return parseInt(this.pool.amount_payable) * 100; // amount in kobo
        },
        poolConvenerName() {
            const { firstname, lastname } = this.pool_convener.profile;

            return `${lastname} ${firstname}`;
        }
    },

    methods: {
        async getPaymentReference() {
            try {
                const payment = await axios.post('/pool/contribute', { pool_id: this.pool_id });

                console.log(payment)

                if (payment.status == 200) {
                    const { reference } = payment.data.message;
                    this.paystack_reference = reference;
                    this.payment_reference = payment.data.message;
                }
            } catch (error) {
                // console.log(error.response)
            }
        },
        callback: async function(response){

            const payment_reference = {
                reference: this.paystack_reference
            }

            try {
                const payment_status = await axios.post('/pool/contribute/verify-payment', payment_reference);

                if (payment_status.status == 200 && payment_status.data.status == 'ok') {

                    const { message } = payment_status.data;

                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'Your contribution has been recorded successfully.'
                    });

                    this.$router.push('/payment-success');


                    // this.paymentSuccess = true // to be used in disabling form if payment has already been made 
                }
            } catch (error) {
                // console.log(error.response);
            }
        },
        close: function(){
            console.log("Payment closed")
        },
    }
}
</script>


<style scoped>

.payButton {
    background: #540D6E !important;
    border: 1px solid #540D6E !important;
    height: 45px;
    line-height: 45px;
    padding: 0 30px !important;
    font-size: 0.8rem !important;
    text-transform: uppercase;
    letter-spacing: 3px !important;
    font-weight: 500;
    color: #fff !important;
    border-radius: 3px;
}

@media (max-width: 425px) {
    .payButton {
        width: 100%;
    }
}

</style>